import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonVariant, ButtonSize, IconColor, IconName, IconSize, usePopoverHandlers, } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
import { makeGetLoggedInState } from '../../redux/session/selectors/SessionSelector';
import { AUTH_POPUP_BUTTON_WRAPPER_ID } from '../../constants/DOMElementsConstants';
import { AccountMenuContainer } from './AccountMenuContainer';
import { AuthenticationContainer } from '../AuthenticationContainer';
import { SecurityLevelsPopup } from '../../components/security-levels-popup/SecurityLevelsPopup';
import { DELAY } from '../../constants/GeneralConstants';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { Breakpoint } from '@yonderland/andes-react';
import { useOAuth } from '../../hooks/useOAuth';
const AccountMenuItemContainer = ({ accountMenu, login, registration, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const [didMount, setDidMount] = useState(false);
    const btnEl = useRef(null);
    const dispatch = useDispatch();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const { authUrl, loggedIn: oauthLoggedIn, postLogin } = useOAuth();
    const loggedIn = useSelector(makeGetLoggedInState()) || oauthLoggedIn;
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const handleOpen = (e) => __awaiter(void 0, void 0, void 0, function* () {
        setTimeout(() => {
            handlePopoverOpen(e, btnEl.current);
        }, DELAY.DELAY_0);
    });
    useEffect(() => {
        dispatch(sessionActions.createInitAction());
        setDidMount(true);
    }, []);
    useEffect(() => {
        if (!loggedIn) {
            return;
        }
        postLogin();
    }, [loggedIn]);
    return (_jsxs(_Fragment, { children: [_jsxs("span", { ref: btnEl, id: AUTH_POPUP_BUTTON_WRAPPER_ID, children: [_jsx(Breakpoint, { from: "lg", children: _jsx(Button, { variant: ButtonVariant.LINK_SUBTLE, size: ButtonSize.SMALL, onClick: !isNewAuth || loggedIn ? handleOpen : undefined, href: isNewAuth && !loggedIn ? authUrl : undefined, dataQA: "account", text: loggedIn ? t('account.account') : t('account.login.title.login'), iconRight: isNewAuth && !loggedIn
                                ? undefined
                                : {
                                    name: anchorEl ? IconName.CHEVRON_UP : IconName.CHEVRON_DOWN,
                                    color: IconColor.ACTION,
                                    size: IconSize.MINOR,
                                } }) }), _jsx(Breakpoint, { until: "lg", children: _jsx(Button, { onClick: !isNewAuth || loggedIn ? handleOpen : undefined, href: isNewAuth && !loggedIn ? authUrl : undefined, variant: ButtonVariant.NAVIGATION, dataQA: "account", icon: {
                                name: loggedIn ? IconName.USER_CHECK_SOLID : IconName.USER_SOLID,
                                size: IconSize.MAJOR,
                            } }) })] }), didMount &&
                (loggedIn === true ? (_jsxs(_Fragment, { children: [_jsx(AccountMenuContainer, { items: accountMenu.items, anchorEl: anchorEl, onClose: handlePopoverClose }), _jsx(SecurityLevelsPopup, {})] })) : (_jsx(AuthenticationContainer, { actionUri: (!!login && login.actionUri) || undefined, anchorEl: anchorEl, onClose: handlePopoverClose, registrationLink: (!!registration && registration.link) || undefined })))] }));
};
export default AccountMenuItemContainer;
